export const SET_STEP_ONE_DATA = '@userCreate/SET_STEP_ONE_DATA';
export const SET_STEP_TWO_DATA = '@userCreate/SET_STEP_TWO_DATA';
export const SET_USER_ID = '@userCreate/SET_USER_ID';
export const RESET_USER_CREATE_DATA = '@userCreate/RESET_USER_CREATE_DATA';
